import { combineReducers } from 'redux';
import view from './viewReducer';

export default combineReducers({
  view,
});
